import api from '../api'
import { getField, updateField } from 'vuex-map-fields'

const emptyState = Array.from(
	[
		'anxious',
		'calm',
		'challenged',
		'confused',
		'excitement',
		'happy',
		'tense',
		'loading',
		'pleasant',
		'sad',
		'unpleasant',
		'zen'
	],
	emotion => {
		return {
			emotion,
			filepath: null
		}
	}
)

const state = {
	stickers: {
		data: [],
		total: 0,
		per_page: 10
	},
	stickersLoading: false,

	viewStickers: {
		emoji: [...emptyState],
		emojiSet: [...emptyState],
		sticker: []
	},

	viewStickersLoading: false,

	viewDetails: {
		id: 0,
		name: '',
		artist: '',
		description: '',
		price: 0
	},

	buttonLoading: false
}

const mutations = {
	updateField
}

const actions = {

	async getList ({ state }, payload) {
		state.stickersLoading = true

		const { data, status } = await api('post', '/resource/list', payload)

		if (status) {
			state.stickers = data
			state.stickersLoading = false
			return
		}

		state.stickersLoading = false
	},

	async view ({ state }, { name, form }) {
		state.viewStickersLoading = true

		const { data, status } = await api('post', '/resource/view', form)

		if (status) {
			if (typeof data.data === 'object') {
				state.viewStickers = data.data
				state.viewStickers.emoji = state.viewStickers.emoji.map(item => {
					return {
						...item,
						filepath: `${process.env.VUE_APP_BASE}img/resources/${item.filepath}`
					}
				})
				state.viewStickers.sticker = state.viewStickers.sticker.map(item => {
					return {
						...item,
						filepath: `${process.env.VUE_APP_BASE}img/resources/${item.filepath}`
					}
				})
				state.viewDetails.name = name
				state.viewDetails.artist = state.viewStickers.sticker[0].artist
				state.viewDetails.description = state.viewStickers.sticker[0].description
			} else {
				state.viewStickers = { moodEmoji: [], sticker: [] }
			}
			state.viewStickersLoading = false
			return
		}

		state.viewStickersLoading = false
	},

	async create ({ state }, { form, router }) {
		state.buttonLoading = true

		const { status } = await api('post', '/resource/create', form)

		if (status) {
			state.buttonLoading = false
			router.push({ name: 'stickers' })
			return
		}

		state.buttonLoading = false
	},

	async update ({ state }, { form, router }) {
		state.buttonLoading = true

		const { status } = await api('post', '/resource/update-stickers', form)

		if (status) {
			state.buttonLoading = false
			router.push({ name: 'stickers' })
			return
		}

		state.buttonLoading = false
	},

	async updateDetails ({ state }, payload) {
		state.buttonLoading = true

		const { status } = await api('post', '/resource/update-setname', payload)

		if (status) {
			state.buttonLoading = false
			return
		}

		state.buttonLoading = false
	},

	async upload ({ state }, { form, id, type }) {
		state.buttonLoading = true

		const { data, status } = await api('post', '/resource/upload', form)

		if (status) {
			const sticker = state.viewStickers[type].find(item => item.id === id)
			sticker.file = data.data.file
			state.buttonLoading = false
			return
		}

		state.buttonLoading = false
	}
}

const getters = {
	getField
}

export default {
	state,
	namespaced: true,
	mutations,
	actions,
	getters
}
